import { makeChartComp } from '../../../util/makeChartComp';
var TinyAreaChart = makeChartComp('TinyArea');
export default TinyAreaChart;
